import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=53c7c322&scoped=true"
var script = {}
import style0 from "./Footer.vue?vue&type=style&index=0&id=53c7c322&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c7c322",
  null
  
)

export default component.exports